import { render, staticRenderFns } from "./remote-work-express.vue?vue&type=template&id=7cddaff8&scoped=true&"
import script from "./remote-work-express.vue?vue&type=script&lang=js&"
export * from "./remote-work-express.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cddaff8",
  null
  
)

export default component.exports